<!-- 接龙模版路由页面 -->
<template>
  <Layout>
    <div
      style="text-align: center; justify-content: center; margin: -14px -12px"
    >
      <div
        class="base-class"
        style="text-align: center; justify-content: center"
      >
        <div style="width: 100%; text-align: left">
          <div class="base-top">
            <!-- 创建通用群按钮 -->
            <div class="create-group-btn" @click="handleCreateGroup">
              <img
                src="@/assets/images/createAdd.png"
                style="
                  height: 40px;
                  width: 40px;
                  border-radius: 50%;
                  overflow: hidden;
                  margin: 0 25px;
                "
              />
              <span class="create-group-text">{{ btnName }}</span>
            </div>
            <!-- 右侧AI发布接龙区域 -->
            <div
              style="margin-left: 13px; cursor: pointer"
              @click="handleAipublish"
            >
              <img
                src="@/assets/images/aicj-0.png"
                alt="AI发布接龙"
                style="height: 94.5px; width: 266.4px"
              />
            </div>
          </div>

          <div class="search-model">
            <div
              class="base-class firstTitle-box"
              style="margin-top: 15px; margin-bottom: 0px; margin-left: 30px"
            >
              <el-tabs v-model="classifyName" @tab-click="handleClick">
                <el-tab-pane
                  v-for="item in mstencilArray"
                  :key="item.classifyName"
                  :label="item.classifyName"
                  :name="item.classifyName"
                ></el-tab-pane>
              </el-tabs>
            </div>
            <div class="search-item">
              <div>
                <i
                  class="el-icon-search"
                  style="
                    font-size: 16px;
                    margin-left: 10px;
                    margin-top: 8px;
                    color: #8e89aa;
                  "
                ></i>
              </div>

              <el-input
                placeholder="输入搜索关键词"
                v-model="filterName"
                class="input-with-search"
                clearable
              >
              </el-input>

              <el-button
                icon="el-icon-search"
                class="search-button"
                @click="searchClick()"
              ></el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="base-class" style="margin: 5px 0">
        <div
          v-for="(item, index) in secondMstencilArray"
          :key="item.id"
          class="sub-tab-item"
          @click="secondClick(item, index)"
          :class="{ secondActive: currentSecondIndex == index }"
        >
          {{ item.classifynamelast }}
        </div>
      </div>

      <div class="base-class" style="display: block; min-height: 400px">
        <div>
          <div style="display: flex; flex-wrap: wrap">
            <div
              class="model-item"
              v-for="(item, index) in tableData"
              :key="index"
              @click="creatClick(item)"
            >
              <div style="display: flex; flex: 1; min-width: 0">
                <el-image
                  class="click-image"
                  :src="imageUrl + item.cover_img"
                  style="
                    background-color: bisque;
                    margin: 11px;
                    border-radius: 3px;
                    margin-left: 0;
                  "
                ></el-image>

                <div class="model-item-text">
                  <p class="model-item-title" :title="item.name">
                    {{ item.name }}
                  </p>
                  <p class="model-item-count">{{ item.auxiliarytitle }}</p>
                </div>
              </div>

              <i class="el-icon-arrow-right"></i>
              <!--              <div class="free-button" @click="creatClick(item)">免费使用</div>-->
            </div>
          </div>
        </div>
      </div>
      <div class="el-pagination-wrap">
        <el-pagination
          background
          layout="sizes,prev, pager, next,total"
          :page-sizes="[20, 50, 100, 200]"
          :total="tablePage.total"
          :current-page="tablePage.pageNum"
          :page-size="tablePage.pageSize"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
      <el-dialog
        title="选择打卡类型"
        :visible.sync="frequencyPopShow"
        width="500px"
      >
        <div>
          <div class="f-list-box">
            <div class="f-inner">
              <div
                class="f-item"
                v-for="(item, index) in frequencyOptionList"
                :class="{ freBgColor: item.isClick == true }"
                :key="index"
                @click="toPageBuild(item.frequencyType, index)"
              >
                <div class="bigTitle">{{ item.bigTitle }}</div>
                <div class="tips">{{ item.tips }}</div>
                <div class="a-right"><i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import {
  getTempleList,
  getFirstTempleType,
  getTwoTempleType,
} from "@/utils/api/activity";
import { imageUrl } from "@/utils/config/commonUrl.js";
import copyrightConfig from "@/utils/config/changeCopyright.js";
const appid = copyrightConfig.AppID;

// import { getUserInfo } from "@/utils/api/user";
/**
 * Basic-table component
 */
export default {
  page: {
    meta: [{ name: "description", content: appConfig.description }],
    title: "模板中心",
  },
  components: { Layout },
  data() {
    return {
      imageUrl: imageUrl,
      filterName: "",

      mstencilArray: [],

      secondMstencilArray: [],

      classifyName: "全部模版", //一级
      classifynamelast: "", //二级
      tableData: [],

      tablePage: {
        pageNum: 1, //
        pageSize: 50,
        total: 0,
      },
      currentSecondIndex: null, //二级分类索引
      tempList: [],
      btnName: appid == "wx7d8daf6d777947a2" ? "创建通用报名" : "创建通用接龙",
      isType: "",
      frequencyPopShow: false,
      frequencyOptionList: [
        {
          bigTitle: "一次性打卡",
          tips: "只需要一次打卡，不需要反复打卡",
          frequencyType: 8,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "按天打卡",
          tips: "每人每天打卡x次",
          frequencyType: 3,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "按周打卡",
          tips: "每人每周打卡x次",
          frequencyType: 2,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "按月打卡",
          tips: "每人每月打卡x次",
          frequencyType: 1,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "法定工作日",
          tips: "只再法定工作日打卡x次，节假日不打卡",
          frequencyType: 4,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "法定节假日",
          tips: "只再法定节假日打卡x次，工作日不打卡",
          frequencyType: 5,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "自定义周几打卡",
          tips: "一周内可自定义星期几打卡x次，其他时间不打卡",
          frequencyType: 6,
          isShow: true,
          isClick: false,
        },
        {
          bigTitle: "自定义日期打卡",
          tips: "适合打卡日期不规律的场景",
          frequencyType: 7,
          isShow: true,
          isClick: false,
        },
      ],
      selectFrequency: "3", // 频率类型 1=每月｜2=每周｜3=每天｜4=法定工作日｜5=法定节假日｜6=自定义周几打卡｜7=自定义日期打卡 | 8=一次性打卡
      commentTitle: "",
      folderId: "", // 文件夹ID
    };
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.replace("/login");
    }

    // 获取路由参数中的 folderId
    this.folderId = this.$route.query.folderId || "";
    console.log(this.folderId, "模板中心 - 当前文件夹ID");

    this.getList();

    this.getFirstTempleType();
  },

  mounted() {
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
    });
  },

  methods: {
    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }

      document.title = `模版中心 - ${suffix}`;
      console.log(document.title, "document.title");
    },
    // 在新标签页打开路由页面
    openInNewTab(route) {
      const { href } = this.$router.resolve(route);
      window.open(href, "_blank");
    },
    handleCreateGroup() {
      if (this.btnName == "创建打卡接龙") {
        this.frequencyPopShow = true;
      }
      if (this.btnName == "创建通用接龙" || this.btnName == "创建通用报名") {
        const query = { alias: "KBWJZBM4", selectType: "add", isType: 106 };
        if (this.folderId) {
          query.folderId = this.folderId;
          query.isInFolder = 2;
        }
        this.openInNewTab({
          path: "/solitaire",
          query: query,
        });
      }
      // 通知
      if (this.btnName == "通用通知") {
        const query = { alias: "I2V4ZJR5", isType: 201 };
        if (this.folderId) {
          query.folderId = this.folderId;
          query.isInFolder = 2;
        }
        this.openInNewTab({
          path: "/groupNotification",
          query: query,
        });
      }
    },
    // 去创建页
    toPageBuild(type, index) {
      this.frequencyPopShow = false;
      const query = {
        alias: "KBWJZBM4",
        selectType: "add",
        isType: this.isType,
        rateType: type,
      };
      if (this.folderId) {
        query.folderId = this.folderId;
        query.isInFolder = 2;
      }
      this.$router.push({
        path: "/solitaire",
        query: query,
      });
    },
    // AI发布
    handleAipublish() {
      this.$router.push({
        path: "/AIPublishJieLong",
      });
    },
    handleSizeChange(pageSize) {
      this.tablePage.pageNum = 1;
      this.tablePage.pageSize = pageSize;
      this.getList();
    },
    handlePageChange(currentPage) {
      this.tablePage.pageNum = currentPage;
      this.getList();
    },
    //搜索方法
    searchClick() {
      this.tablePage.pageNum = 1;
      this.getList();
    },

    getList(templeTypeId) {
      //获取列表数据
      // latest-request 保护：只有最后一次请求的响应允许写入列表，
      // 防止旧筛选的慢响应覆盖新筛选结果
      this._listReqSeq = (this._listReqSeq || 0) + 1;
      const reqSeq = this._listReqSeq;
      getTempleList({
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.pageNum,
        keyword: this.filterName,
        classifyName: this.classifyName == "全部模版" ? "" : this.classifyName,
        classifynamelast: this.classifynamelast,
        templeTypeId: templeTypeId ? templeTypeId : "",
      }).then((res) => {
        if (reqSeq !== this._listReqSeq) return;
        console.log(res, "请求列表数据");
        if (res.status == 1) {
          this.tableData = res.data.list;
          this.tablePage.total = res.data.total;
        }
      });
    },

    // 获取一级分类
    getFirstTempleType() {
      getFirstTempleType({
        activityType: this.isType,
        activityBigType: "",
      }).then((res) => {
        console.log(res, "一级分类数据");
        if (res.status == 1) {
          this.mstencilArray.push({
            classifyName: "全部模版",
          });

          for (const key in res.data) {
            let item = res.data[key];
            this.mstencilArray.push(item);
          }
          this.mstencilArray = this.mstencilArray.slice(0, 9);
        }
      });
    },

    // 一级分类点击方法
    handleClick(tab, event) {
      console.log(tab, event, "handleClick");
      console.log(this.classifyName, "classifyNameclassifyName");

      this.classifynamelast = "";

      this.tablePage.pageNum = 1;

      this.currentSecondIndex = null;

      if (this.classifyName == "签到打卡") {
        const newItem = {
          cover_img: "/12jielong/lsyJL/tyiconnew.png",
          name: "创建打卡接龙",
          auxiliarytitle: "创建通用的空白打卡",
          id: 2,
          activity_big_type: 1,
          activity_type: 109,
        };
        this.btnName = "创建打卡接龙";
        this.isType = 109;
        this.$set(this.tempList, 0, newItem);
      } else if (this.classifyName && this.classifyName.includes("通知")) {
        const newItem = {
          cover_img: "/12jielong/lsyJL/tyiconnew.png",
          name: "创建通用通知",
          auxiliarytitle: "创建通用的空白通知",
          id: 2,
          activity_big_type: 1,
          activity_type: 201,
        };
        this.$set(this.tempList, 0, newItem);
        this.btnName = "创建通用通知";
        this.isType = 201;
      } else {
        const newItem = {
          cover_img: "/12jielong/lsyJL/tyiconnew.png",
          name: "创建通用接龙",
          auxiliarytitle: "创建通用的空白接龙",
          id: 2,
          activity_big_type: 1,
          activity_type: 106,
        };
        this.$set(this.tempList, 0, newItem);
        this.btnName =
          copyrightConfig.AppID == "wx7d8daf6d777947a2"
            ? "创建通用报名"
            : "创建通用接龙";
        this.isType = 106;
      }

      this.getList();

      this.getTwoTempleType();
    },

    // 获取二级分类
    getTwoTempleType() {
      var activityBigType = 1;
      if (this.classifyName == "通知公告") {
        activityBigType = 2;
      }
      // latest-request 保护：快速切换一级分类时，
      // 只有最后一次请求允许写入二级分类列表
      this._twoTypeReqSeq = (this._twoTypeReqSeq || 0) + 1;
      const reqSeq = this._twoTypeReqSeq;
      getTwoTempleType({
        activityBigType: activityBigType,
        classifyName: this.classifyName,
      }).then((res) => {
        if (reqSeq !== this._twoTypeReqSeq) return;
        console.log(res, "二级分类数据");
        if (res.status == 1) {
          this.secondMstencilArray = res.data;
        }
      });
    },

    // 二级分类点击方法
    secondClick(item, index) {
      console.log(item);
      this.currentSecondIndex = index;
      this.classifynamelast = item.classifynamelast;
      this.getList(item.id);
    },

    // 创建自定义接龙
    creatClick(item) {
      console.log(item, "item");
      // 构建基础查询参数
      const buildQuery = (alias, selectType, isType) => {
        const query = { alias: alias, selectType: selectType, isType: isType };
        if (this.folderId) {
          query.folderId = this.folderId;
          query.isInFolder = 2;
        }
        return query;
      };

      if (item.activity_big_type == 2) {
        this.openInNewTab({
          path: "/groupNotification",
          query: buildQuery(item.activity_key, "add", 201),
        });
      }
      if (item.activity_type == 107) {
        this.openInNewTab({
          path: "/solitaire",
          query: buildQuery(item.activity_key, "add", 107),
        });
      }
      if (item.activity_type == 109) {
        this.openInNewTab({
          path: "/solitaire",
          query: buildQuery(item.activity_key, "add", 109),
        });
      }
      if (item.activity_type == 110) {
        this.openInNewTab({
          path: "/solitaire",
          query: buildQuery(item.activity_key, "add", 110),
        });
      }
      if (item.activity_type == 106) {
        this.openInNewTab({
          path: "/solitaire",
          query: buildQuery(item.activity_key, "add", 106),
        });
      }
      if (item.activity_type == 105) {
        this.openInNewTab({
          path: "/solitaire",
          query: buildQuery(item.activity_key, "add", 105),
        });
      }
      if (item.activity_type == 104) {
        this.openInNewTab({
          path: "/solitaire",
          query: buildQuery(item.activity_key, "add", 104),
        });
      }
      // console.log(item, "item");
      // this.$router.push({
      //   path: "/solitaire",
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.base-class {
  display: flex;
  //transform: scale(0.9); /* 缩小页面至90% */
  //transform-origin: top left; /* 确保缩放从左上角开始 */
  // min-width: 1236px;
}

.top-item {
  width: 397px;
  height: 120px;
  margin-right: 15px;
}

.top-image {
  width: 397px;
  height: 120px;
  position: absolute;
  z-index: -1;
}

.top-title {
  color: #ffffff;
  line-height: 33px;
  font-size: 24px;
  font-weight: 400;
  margin-left: 31px;
  margin-top: 18px;
  margin-bottom: 5px;
}

.top-count {
  color: #ffffff;
  line-height: 22px;
  font-size: 15px;
  font-weight: 200;
  margin-bottom: 13px;
}

.creat-text {
  color: #ffffff;
  line-height: 22px;
  text-align: right;
  font-size: 14px;
  margin-right: 10px;
}

.click-item {
  width: 235px;
  height: 93px;
  margin-right: 12px;
  background-color: #ffffff;
  margin-top: 10px;
  border-radius: 3px;
  display: flex;
}

.click-image {
  width: 60px;
  height: 60px;
  margin-top: 10px;
  margin-left: 20px;
  flex-shrink: 0;
}

.click-title {
  font-size: 19px;
  color: #2b2f36;
  line-height: 28px;
  margin-top: 21px;
  margin-bottom: 12px;
  margin-right: 5px;
}

.click-creat {
  color: #a2a2a2;
  line-height: 20px;
  font-size: 13px;
}

.model-top {
  justify-content: space-between;
  display: flex;
  width: 1220px;
  margin-top: 20px;
}

.model-top-title {
  color: #2b2f36;
  line-height: 21px;
  font-size: 16px;
  font-weight: 500;
}

.model-top-more {
  color: #686868;
  line-height: 19px;
  font-size: 14px;
}

.model-item {
  width: calc(20% - 10px); /* 动态计算宽度，减去间距 */
  height: 80px;
  //min-width: 345px;
  background-color: #ffffff;
  border-radius: 4px;
  display: flex;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;

  &:hover .model-item-title {
    color: #1877ff; /* 鼠标悬浮时的字体颜色 */
  }

  @media (min-width: 769px) and (max-width: 1200px) {
    width: calc(33.33% - 10px); /* 平板端每行3个 */
    height: 75px;
  }

  @media (min-width: 1201px) and (max-width: 1440px) {
    width: calc(25% - 10px); /* 小屏桌面每行4个 */
  }

  @media (min-width: 1441px) {
    width: calc(20% - 10px); /* 大屏桌面每行5个 */
  }
}

.model-item-text {
  flex: 1;
  min-width: 0; /* 允许收缩，保证标题/描述 ellipsis 生效且内容不溢出卡片 */
}

.model-item-title {
  color: #2a2b3c;
  line-height: 22px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 18px;
  margin-bottom: 10px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  /* 响应式字体大小 */
  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
    margin-top: 15px;
    margin-bottom: 8px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 13px;
    line-height: 20px;
  }
}

.model-item-count {
  color: #777;
  line-height: 20px;
  font-size: 14px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;

  /* 响应式字体大小 */
  @media (max-width: 768px) {
    font-size: 11px;
    line-height: 16px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    font-size: 12px;
    line-height: 18px;
  }
}

.free-button {
  cursor: pointer;
  width: 80px;
  height: 31px;
  background-color: #1877ff;
  border-radius: 18px;
  text-align: center;
  line-height: 31px;
  color: #ffffff;
  font-size: 13px;
  margin-top: 30px;
  margin-left: 10px;
}

::v-deep .el-tabs__nav-wrap::after {
  position: static !important;
}

::v-deep .el-tabs__item {
  color: #686868;
  padding-top: 0 9px;
}

::v-deep .el-tabs__item.is-active {
  color: #323b5a;
}

::v-deep .el-tabs__item.hover {
  color: #323b5a;
}

.sub-tab-item {
  text-align: center;
  background-color: #eeeeee;
  color: #909090;
  margin-right: 10px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 15px;
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  cursor: pointer;
}

.search-item {
  background-color: #f8f8f8;
  /*width: 420px;*/
  height: 30px;
  border-radius: 20px;
  display: flex;
  margin-right: 20px;
  overflow: hidden;

  :deep(.el-input__inner) {
    height: 30px;
    line-height: 30px;
  }

  :deep(.el-input__suffix) {
    top: -4px;
  }
}

.search-button {
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #1877ff;
  font-size: 16px;
  color: white;
  border-radius: 30px;
  text-align: center;
  line-height: 30px;
  //padding-top: 7px;
  //margin-top: 5px;
}

.input-with-search {
  //margin-left: 5px;
  //margin-top: 5px;
  width: 170px;
}

.input-with-search {
  :deep(.el-input__inner) {
    border: 0px solid #dcdfe6;
    background-color: #f8f8f8;
  }
}

:deep(.el-tabs__item) {
  padding: 0 9px;
  font-size: 16px;
}

.secondActive {
  background: #d7e7ff;
  border: 2rpx solid #1877ff;
  color: #1877ff;
}

// el-input__inner
.create-group-btn {
  display: flex;
  align-items: center;
  width: 266.4px;
  height: 94.5px;
  background: linear-gradient(180deg, #3a41ef, #888cf7);
  border-radius: 5px;
  color: #fff;
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(94, 139, 255, 0.08);
  transition: box-shadow 0.2s;
}

.create-group-btn:hover {
  box-shadow: 0 4px 16px rgba(94, 139, 255, 0.18);
}

.create-group-text {
  font-size: 20px;
  font-weight: 500;
}

.ai-publish-text {
  font-size: 20px;
  color: #1877ff;
  font-weight: bold;
  margin-left: 8px;
  vertical-align: middle;
}

.base-top {
  display: flex;
  align-items: center;
  /*margin-top: 10px;*/
}

.search-model {
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  background-color: #fff;
  height: 63px;
  min-width: 1000px;
}

.firstTitle-box {
  /*max-width: 600px;*/
  /*overflow-x: auto;*/
  /*overflow-y: hidden;*/
}

.f-list-box {
  padding: 15px 15px;
  box-sizing: border-box;
  background-color: #f8f8f8;
}

.f-title {
  color: #666;
  margin-bottom: 15px;
  text-align: center;
}

.f-inner {
  background-color: white;
  border-radius: 10px;
  /*width: 94%;*/
  margin: 0 auto;
  padding: 0 13px;
}

.f-item {
  padding: 10px 0;
  border-bottom: 1px solid #eee;
  position: relative;

  .bigTitle {
    color: black;
    margin-bottom: 5px;
    text-align: left;
    font-weight: bold;
  }

  .tips {
    font-size: 11px;
    color: grey;
    text-align: left;
  }
}

.a-right {
  position: absolute;
  right: 0px;
  top: 22px;
}

.el-pagination-wrap {
  display: flex;
  justify-content: flex-end;
  height: 50px;
  align-items: baseline;
}

//选中 #B8D5FF   #1877FF
</style>
